var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "activity-filter d-flex align-items-center flex-row" },
    [
      _vm.currentPage === _vm.ActivitiesTabs.ClientActivities
        ? _c("span", [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("notifications.messages.activitiesInPast")) +
                "\n  "
            ),
          ])
        : _c("span", [
            _vm._v(
              " " +
                _vm._s(_vm.$t("notifications.messages.activitiesInNext")) +
                " "
            ),
          ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group-material form-group-material-number mx-1" },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.filtersLocal.days,
                expression: "filtersLocal.days",
              },
            ],
            staticClass: "material-input form-control",
            attrs: { type: "number", min: "1", step: "1", maxlength: "3" },
            domProps: { value: _vm.filtersLocal.days },
            on: {
              change: _vm.handleChange,
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.filtersLocal, "days", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "bar" }),
        ]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "text-lowercase" }, [
        _vm._v("\n    " + _vm._s(_vm.$tc("global.words.day", 2)) + "\n  "),
      ]),
      _vm._v(" "),
      _vm.currentPage === _vm.ActivitiesTabs.UpcomingActivities
        ? _c(
            "span",
            { staticClass: "pretty p-switch p-fill mr-2 font-sm ml-5" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.filtersLocal.expired,
                    expression: "filtersLocal.expired",
                  },
                ],
                attrs: {
                  id: "filter-expired-checkbox",
                  type: "checkbox",
                  name: "filter-expired-checkbox",
                },
                domProps: {
                  checked: Array.isArray(_vm.filtersLocal.expired)
                    ? _vm._i(_vm.filtersLocal.expired, null) > -1
                    : _vm.filtersLocal.expired,
                },
                on: {
                  change: [
                    function ($event) {
                      var $$a = _vm.filtersLocal.expired,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.filtersLocal,
                              "expired",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.filtersLocal,
                              "expired",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.filtersLocal, "expired", $$c)
                      }
                    },
                    _vm.handleChange,
                  ],
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "state" }, [
                _c(
                  "label",
                  {
                    staticClass: "text-gray",
                    attrs: { for: "filter-expired-checkbox" },
                  },
                  [_vm._v(_vm._s(_vm.$t("boards.filters.pastDue")) + "?")]
                ),
              ]),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }